import { hideElement, showElement } from './dpitHidden';
import { getNthStr, updateCssVar } from './dpitUtilsInc';


const MCE_FLOATING_PANELS_SELECTORS = '.mce-inline-toolbar-grp, .mce-floatpanel, #mce-modal-block, #wp-link-backdrop, #wp-link-wrap, #__wp-uploader-id-2, #mla-terms-search-overlay';

export default class DpTinyMceDialog {
	constructor(config, onTmceSaved, onTmceCancel, dpDebugEn) {
		this.config = config;
		this.onTmceCancel = onTmceCancel;
		if (dpDebugEn) console.log('[dpit] INIT DpTinyMceDialog');
		$('#dp-step-content-edit .button-primary').on('click', () => {
			if (onTmceSaved) {
				$('#dp-tmce-editor-tmce').trigger('click');
				let htmlContent = tinymce.get('dp-tmce-editor').getContent();
				htmlContent = this.forceTargetBlank(htmlContent);
				htmlContent = htmlContent.replace(/<a(?! target="_blank")/g, '<a target="_blank"');
				onTmceSaved(this.target, htmlContent);

				this.close(false);
				/*
				if (!this.containsShortCode(htmlContent)) {
					onTmceSaved(this.target, htmlContent);
					this.close(false);
				} else {

					// ajax
				}*/
			}
			else {
				this.close(false);
			}
		});

		$('#dpit-mce-dialog-close, #dp-step-content-edit__backdrop').on('click', () => {
			this.close();
		});
		document.addEventListener('keydown', this.keydown.bind(this));
	}

	forceTargetBlank(htmlContent) {

		return htmlContent;
	}

	containsShortCode(htmlContent) {
		if (!htmlContent) return false;
		const shortCodes = htmlContent.match(/\[[^[]*[^\]]*\]/ig);
		return shortCodes ? shortCodes.length > 0 : false;
	}

	keydown(event) {

		// Escape key.
		if (this.modalOpened && event.keyCode === 27) {
			this.close();
		}
	}


	showOverlay() {
		$('#dp-step-content-edit__backdrop').addClass('dpit-active');
	}

	hideOverlay() {
		$('#dp-step-content-edit__backdrop').removeClass('dpit-active');
	}

	open(target, data, stepIdxOneBased) {
		this.modalOpened = true;
		if (stepIdxOneBased !== false && !isNaN(stepIdxOneBased)) {
			const step = getNthStr(stepIdxOneBased);
			$('#dp-step-content-edit .dpit-modal__title').html(this.config.title.replace('%s', step));
		}

		$('#dp-step-content-edit').addClass('dpit-active');
		this.showOverlay();
		this.hadDpitRelPos = $('body').hasClass('dpit-relative-position');
		if (this.hadDpitRelPos) {
			$('body').removeClass('dpit-relative-position');
		}
		updateCssVar('--dpit-scroll-top', (document.documentElement.scrollTop || document.body.scrollTop) + 'px');
		$('body').addClass('dpit-no-scroll');

		this.target = target;
		$('#dp-tmce-editor-tmce').trigger('click');
		this.editor = window.tinyMCE.get('dp-tmce-editor');
		this.editor.setContent(data ?? '', { format: 'html' });
		if (this.editor.selection) {
			this.editor.selection.select(this.editor.getBody(), true);
			this.editor.selection.collapse(false);
		}
		this.enableMceFloatPanels();
		this.editor.focus();
	}



	enableMceFloatPanels() {
		$(MCE_FLOATING_PANELS_SELECTORS).each((_, element) => {
			showElement(element);
		});
	}
	disableMceFloatPanels() {
		$(MCE_FLOATING_PANELS_SELECTORS).each((_, element) => {
			hideElement(element);
		});
	}


	close(wasCanceled = true) {
		this.target = null;
		this.modalOpened = false;
		this.disableMceFloatPanels();

		$('#dp-step-content-edit').removeClass('dpit-active');
		this.hideOverlay();
		$('body').removeClass('dpit-no-scroll');
		if (wasCanceled && this.onTmceCancel) this.onTmceCancel();
		if (this.hadDpitRelPos) {
			$('body').addClass('dpit-relative-position');
		}
	}
}